import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import data from "../ApiUrl/meta_api.js";
// import apiUrl from "../Environment/Api.js";
import "../../assets/css/Informationtechnology.css";

function InformationTechnology() {
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const informationTechnology = data[0]?.information_technology_page;
    if (informationTechnology) {
      setMeta(informationTechnology);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to open the modal
  const Full_Stack_Development = () => {
    setIsCourseData("Full-Stack Development");
    setIsModalOpen(true);
  };

  const Web_Development = () => {
    setIsCourseData("Web Development");
    setIsModalOpen(true);
  };

  const Data_Analytics = () => {
    setIsCourseData("Data Analytics");
    setIsModalOpen(true);
  };

  const Mobile_App_Development = () => {
    setIsCourseData("Mobile App Development");
    setIsModalOpen(true);
  };

  const UI_UX_Designing = () => {
    setIsCourseData("UI/UX Designing");
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsCourseData("");
    setIsModalOpen(false);
  };

  const [isCourseData, setIsCourseData] = useState(null);

  // const [selectedCourse, setSelectedCourse] = useState("beginner");

  const formatTime = () => {
    const currentTime = new Date();
    return currentTime.toLocaleTimeString("en-GB", { hour12: false }); // 24-hour format
  };

  const handleSendMessage = async () => {
    const newErrors = {};

    // Validate Name
    if (!formValues.student_name.trim()) {
      newErrors.student_name = "Name is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(formValues.student_name)) {
      newErrors.student_name = "Name must contain only letters.";
    }

    // Validate Email
    if (!formValues.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    // Validate Mobile
    if (!formValues.mobile_no.trim()) {
      newErrors.mobile_no = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formValues.mobile_no)) {
      newErrors.mobile_no = "Mobile number must be 10 digits.";
    }

    // Validate Location
    if (!formValues.location.trim()) {
      newErrors.location = "Location is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(formValues.location)) {
      newErrors.location = "Location must contain only letters.";
    }

    // If there are errors, update state and stop submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Clear errors and proceed with API call
    setErrors({});
    console.log("Form Values: ", formValues);

    setIsLoading(true);
    setIsPageDisabled(true);

    try {
      const response = await axios.post(
        // `${apiUrl}/leads_website`,
        {
          ...formValues,
          fetched_course: isCourseData,
          Enquiry_time: formatTime(), // Only send time
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setFormValues({
        student_name: "",
        email: "",
        mobile_no: "",
        location: "",
        Prefered_course: "",
        Source_type: "",
        Enquiry_date: new Date().toISOString().split("T")[0],
        Enquiry_time: "",
      });

      console.log("Data submitted successfully:", response.data);
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("An error occurred while submitting the data. Please try again.");
    } finally {
      // Ensure loader stops after 2 seconds
      setTimeout(() => {
        setIsLoading(false);
        setIsPageDisabled(false);
      }, 2000);
    }
  };

  const [errors, setErrors] = useState({});

  const [formValues, setFormValues] = useState({
    student_name: "",
    email: "",
    mobile_no: "",
    location: "",
    Prefered_course: "",
    source: "Website",
    enquiry_date: new Date().toISOString().split("T")[0],
  });

  const handleChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      Prefered_course: isCourseData ? isCourseData : "", // set the specific field you want to update
    }));

    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "location") {
      if (value === "Others") {
        setShowOtherLocationField(true);
      } else {
        setShowOtherLocationField(false);
      }
    }
  };

  const [showOtherLocationField, setShowOtherLocationField] = useState(false); // State for custom location field

  const [isLoading, setIsLoading] = useState(false);
  const [isPageDisabled, setIsPageDisabled] = useState(false);
  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Information Technology"}</title>
        <link
          rel="canonical"
          href="https://skimitaracademy.com/industrialtechnology"
        />
      </Helmet>

      {isLoading && (
        <div className="loader">
          <img
            className=""
            alt=""
            src={require("../../assets/images/SH Logo.webp")}
          ></img>
        </div>
      )}

      <div className={`page-container ${isPageDisabled ? "blurred" : ""}`}>
        <div
          className="backgroundCommenImage mb-5"
          style={{
            // backgroundImage: `url(${require("../../assets/images/Intern/Information Technology/IT Banner.png")})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          {" "}
          <div className="backgroundcommenImageBannerText">
            {/* <h1 className="text-danger">Digital Marketing</h1> */}
          </div>
        </div>
        <div className="container  ">
          <div className="row">
            <div className="col-lg-12  " data-aos="fade-up">
              <div className="">
                <h1 className="commomtextcolor text-danger text-center">
                  Welcome to Skimitar Hindusthan Pvt Ltd – IT Innovation Hub
                </h1>
                <h3 className="text-danger"></h3>
              </div>
              <div>
                <p className="dm_onepara">
                  Skimitar Hindusthan Pvt Ltd, we are dedicated to empowering
                  individuals and businesses with advanced IT solutions and
                  training programs. From Full-Stack Development to Web
                  Development, Data Analytics, App Development, and UI/UX
                  Design, we offer comprehensive services and skill-building
                  courses tailored to the evolving demands of the tech industry.
                </p>
                <p className="dm_onepara">
                  Whether you're a business looking for custom software
                  solutions, a startup in need of cutting-edge web or mobile
                  apps, or a professional aiming to upgrade your skills, we
                  provide expert-led training and development services to help
                  you stay ahead in the digital world.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-5 p-5">
          <div className="col-lg-6" data-aos="fade-left">
            <div className="container Expert_leds">
              <h2 className="text-start commomtextcolor dM_Para text-danger ">
                Why Choose Our Training Program
              </h2>
              <p class="mt-5 paraSi">
                <i
                  class="fa-solid fa-backward fa-flip-horizontal mx-2"
                  style={{ color: "#dc3545" }}
                ></i>
                <span class="fw-bold">
                  Industry-Experienced Trainers & Developers
                </span>{" "}
                – Learn from experts with hands-on experience in real-world
                projects.
              </p>
              <p class="paraSi">
                <i
                  class="fa-solid fa-backward fa-flip-horizontal mx-2"
                  style={{ color: "#dc3545" }}
                ></i>
                <span class="fw-bold">Hands-on Project-Based Learning</span> –
                Gain practical skills through real-world projects and case
                studies.
              </p>
              <p class="paraSi">
                <i
                  class="fa-solid fa-backward fa-flip-horizontal mx-2"
                  style={{ color: "#dc3545" }}
                ></i>
                <span class="fw-bold">
                  End-to-End IT Solutions for Businesses{" "}
                </span>{" "}
                – From development to deployment, we offer customized solutions
                for startups, enterprises, and SMEs.
              </p>
              <p class="paraSi">
                <i
                  class="fa-solid fa-backward fa-flip-horizontal mx-2"
                  style={{ color: "#dc3545" }}
                ></i>
                <span class="fw-bold">
                  Up-to-Date with the Latest Technologies{" "}
                </span>{" "}
                – We stay ahead with cutting-edge frameworks, tools, and
                methodologies.
              </p>
              <p class="paraSi">
                <i
                  class="fa-solid fa-backward fa-flip-horizontal mx-2"
                  style={{ color: "#dc3545" }}
                ></i>
                <span class="fw-bold">Affordable & Customizable Services </span>{" "}
                – Flexible training programs and IT solutions tailored to your
                budget and requirements.
              </p>
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-right">
            <img
              className="Training_img mt-1"
              src={require("../../assets/images/Intern/Information Technology/html-css-collage-concept-with-person.jpg")}
            ></img>
          </div>
        </div>
        {/* our training program start */}

        {/* Our Training Programs */}
        <div
          className="container our_training_cONtainer"
          style={{ padding: "0 15px" }}
        >
          <div className="iatHeadings text-center mb-4 mb-md-5">
            <h2
              className="text-danger"
              style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}
            >
              Our Training Programs
            </h2>
          </div>

          <div className="mt-4 mt-md-5">
            <div className="row" data-aos="fade-up">
              {/* Full-Stack Development Card */}
              <div className="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
                <div
                  className="card blogCardSection h-100 shadow-sm"
                  style={{
                    border: "none",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={require("../../assets/images/Intern/Information Technology/fullstack.jpg")}
                    className="ImageCardBlog1 w-100"
                    alt="Full-Stack Development"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                  <div className="card-body d-flex flex-column">
                    <div className="mb-2">
                      <p
                        className="blogCardDevelopment text-muted mb-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Information Technology
                      </p>
                    </div>
                    <h5
                      className="text-danger text-center mb-3"
                      style={{
                        fontSize: "clamp(1.1rem, 2vw, 1.3rem)",
                        fontWeight: "600",
                      }}
                    >
                      Full-Stack Development
                    </h5>
                    <div className="flex-grow-1 mb-3">
                      <p
                        className="commonPages"
                        style={{
                          fontSize: "14px",
                          lineHeight: "1.6",
                          color: "#555",
                          textAlign: "justify",
                        }}
                      >
                        Java and Python for the backend, ensuring scalability
                        and performance. The frontend is built with HTML, CSS,
                        JavaScript, and Bootstrap, providing a responsive user
                        interface. It supports MySQL and MongoDB for data
                        management and uses React or Angular for dynamic and
                        interactive web applications.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <p
                            className="mb-0"
                            style={{ fontSize: "14px", color: "#666" }}
                          >
                            <i className="fa-solid fa-book me-1"></i> Duration -
                            4 months
                          </p>
                        </div>
                        <div className="col-5 text-end">
                          <button
                            className="btn btn-success"
                            onClick={Full_Stack_Development}
                            style={{
                              fontSize: "clamp(11px, 1.5vw, 13px)",
                              padding: "6px 12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            View Course
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Web Development Card */}
              <div className="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
                <div
                  className="card blogCardSection h-100 shadow-sm"
                  style={{
                    border: "none",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={require("../../assets/images/Intern/Information Technology/web.jpg")}
                    className="ImageCardBlog1 w-100"
                    alt="Web Development"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                  <div className="card-body d-flex flex-column">
                    <div className="mb-2">
                      <p
                        className="blogCardDevelopment text-muted mb-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Information Technology
                      </p>
                    </div>
                    <h5
                      className="text-danger text-center mb-3"
                      style={{
                        fontSize: "clamp(1.1rem, 2vw, 1.3rem)",
                        fontWeight: "600",
                      }}
                    >
                      Web Development
                    </h5>
                    <div className="flex-grow-1 mb-3">
                      <p
                        className="commonPages"
                        style={{
                          fontSize: "14px",
                          lineHeight: "1.6",
                          color: "#555",
                          textAlign: "justify",
                        }}
                      >
                        HTML, CSS, JavaScript, and Bootstrap for the frontend,
                        ensuring a responsive and visually appealing interface.
                        The backend is powered by PHP, providing efficient
                        server-side functionality. It also supports WordPress
                        and Shopify for CMS and e-commerce, with seamless
                        RESTful API integration for enhanced connectivity.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <p
                            className="mb-0"
                            style={{ fontSize: "14px", color: "#666" }}
                          >
                            <i className="fa-solid fa-book me-1"></i> Duration -
                            2 months
                          </p>
                        </div>
                        <div className="col-5 text-end">
                          <button
                            className="btn btn-success"
                            onClick={Web_Development}
                            style={{
                              fontSize: "clamp(11px, 1.5vw, 13px)",
                              padding: "6px 12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            View Course
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mobile App Development Card */}
              <div className="col-12 col-md-6 col-lg-4">
                <div
                  className="card blogCardSection h-100 shadow-sm"
                  style={{
                    border: "none",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={require("../../assets/images/Intern/Information Technology/app.jpg")}
                    className="ImageCardBlog1 w-100"
                    alt="Mobile App Development"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                  <div className="card-body d-flex flex-column">
                    <div className="mb-2">
                      <p
                        className="blogCardDevelopment text-muted mb-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Information Technology
                      </p>
                    </div>
                    <h5
                      className="text-danger text-center mb-3"
                      style={{
                        fontSize: "clamp(1.1rem, 2vw, 1.3rem)",
                        fontWeight: "600",
                      }}
                    >
                      Mobile App Development
                    </h5>
                    <div className="flex-grow-1 mb-3">
                      <p
                        className="commonPages"
                        style={{
                          fontSize: "14px",
                          lineHeight: "1.6",
                          color: "#555",
                          textAlign: "justify",
                        }}
                      >
                        Java and Kotlin are used for Android, while Swift powers
                        iOS applications. React Native and Flutter enable
                        cross-platform development for seamless experiences
                        across devices. The backend is supported by Firebase,
                        Node.js, and Spring Boot for efficient data handling and
                        server-side operations.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <p
                            className="mb-0"
                            style={{ fontSize: "14px", color: "#666" }}
                          >
                            <i className="fa-solid fa-book me-1"></i> Duration -
                            4 months
                          </p>
                        </div>
                        <div className="col-5 text-end">
                          <button
                            className="btn btn-success"
                            onClick={Mobile_App_Development}
                            style={{
                              fontSize: "clamp(11px, 1.5vw, 13px)",
                              padding: "6px 12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            View Course
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Second Row - Data Analytics and UI/UX Designing */}
          <div className="mt-4 mt-md-5 mb-4 mb-md-5">
            <div className="row justify-content-center" data-aos="fade-up">
              {/* Data Analytics Card */}
              <div className="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
                <div
                  className="card blogCardSection h-100 shadow-sm"
                  style={{
                    border: "none",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={require("../../assets/images/Intern/Information Technology/data analysis.jpg")}
                    className="ImageCardBlog1 w-100"
                    alt="Data Analytics"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                  <div className="card-body d-flex flex-column">
                    <div className="mb-2">
                      <p
                        className="blogCardDevelopment text-muted mb-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Information Technology
                      </p>
                    </div>
                    <h5
                      className="text-danger text-center mb-3"
                      style={{
                        fontSize: "clamp(1.1rem, 2vw, 1.3rem)",
                        fontWeight: "600",
                      }}
                    >
                      Data Analytics
                    </h5>
                    <div className="flex-grow-1 mb-3">
                      <p
                        className="commonPages"
                        style={{
                          fontSize: "14px",
                          lineHeight: "1.6",
                          color: "#555",
                          textAlign: "justify",
                        }}
                      >
                        Python and SQL are essential for handling and querying
                        data efficiently. Power BI and Matplotlib help in
                        creating insightful visualizations. PyTorch is used for
                        machine learning applications, while AWS and Google
                        Cloud support big data and cloud-based solutions.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <p
                            className="mb-0"
                            style={{ fontSize: "14px", color: "#666" }}
                          >
                            <i className="fa-solid fa-book me-1"></i> Duration -
                            3 months
                          </p>
                        </div>
                        <div className="col-5 text-end">
                          <button
                            className="btn btn-success"
                            onClick={Data_Analytics}
                            style={{
                              fontSize: "clamp(11px, 1.5vw, 13px)",
                              padding: "6px 12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            View Course
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* UI/UX Designing Card */}
              <div className="col-12 col-md-6 col-lg-4">
                <div
                  className="card blogCardSection h-100 shadow-sm"
                  style={{
                    border: "none",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={require("../../assets/images/Intern/Information Technology/ui.jpg")}
                    className="ImageCardBlog1 w-100"
                    alt="UI/UX Designing"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                  <div className="card-body d-flex flex-column">
                    <div className="mb-2">
                      <p
                        className="blogCardDevelopment text-muted mb-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Information Technology
                      </p>
                    </div>
                    <h5
                      className="text-danger text-center mb-3"
                      style={{
                        fontSize: "clamp(1.1rem, 2vw, 1.3rem)",
                        fontWeight: "600",
                      }}
                    >
                      UI/UX Designing
                    </h5>
                    <div className="flex-grow-1 mb-3">
                      <p
                        className="commonPages"
                        style={{
                          fontSize: "14px",
                          lineHeight: "1.6",
                          color: "#555",
                          textAlign: "justify",
                        }}
                      >
                        Figma, Adobe XD, and Sketch help design interactive
                        layouts, while user research methods such as heatmaps
                        and A/B testing improve usability. Responsive UI designs
                        ensure seamless experiences across devices, with
                        branding elements like logos and typography enhancing
                        visual identity.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <p
                            className="mb-0"
                            style={{ fontSize: "14px", color: "#666" }}
                          >
                            <i className="fa-solid fa-book me-1"></i> Duration -
                            2 months
                          </p>
                        </div>
                        <div className="col-5 text-end">
                          <button
                            className="btn btn-success"
                            onClick={UI_UX_Designing}
                            style={{
                              fontSize: "clamp(11px, 1.5vw, 13px)",
                              padding: "6px 12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            View Course
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="commonmargin">
          <div className="container begin_your_automation mb-5">
            <div className="row ">
              <div className="col-lg-6" data-aos="fade-right">
                <h3 className=" Journey text-start text-danger commomtextcolor">
                  How to Begin Your IT Journey
                </h3>

                <div className="row mt-4">
                  <div className="col-lg-2">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-industry mx-4"></i>{" "}
                    </h2>
                  </div>
                  <div className="col-lg-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Understand the Fundamentals :
                      </span>
                      Learn the basics of programming, databases, and version
                      control to build a strong foundation.
                    </h6>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-2">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-arrow-up-right-from-square mx-4"></i>
                    </h2>
                  </div>
                  <div className="col-lg-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Choose Your Path :
                      </span>
                      Identify your area of interest (Full-Stack, Web
                      Development, Data Analytics, Mobile App Development, or
                      UI/UX) and select relevant technologies.
                    </h6>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-2">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-chart-line mx-4"></i>{" "}
                    </h2>
                  </div>
                  <div className="col-lg-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Build Hands-on Projects :
                      </span>{" "}
                      Apply your knowledge by working on real-world projects and
                      creating a portfolio to showcase your skills.
                    </h6>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-2">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-building-columns mx-4"></i>{" "}
                    </h2>
                  </div>
                  <div className="col-lg-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Master Industry Tools :
                      </span>{" "}
                      Gain expertise in popular frameworks, cloud platforms, and
                      deployment strategies relevant to your chosen field.
                    </h6>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-2">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-wifi mx-4"></i>
                    </h2>
                  </div>
                  <div className="col-lg-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Stay Updated & Network :
                      </span>{" "}
                      Follow industry trends, join developer communities, and
                      participate in hackathons or open-source contributions.
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mt-4">
                <div className="row">
                  <div className="col-lg-8" data-aos="fade-up">
                    <div className="Automation mt-3">
                      <img
                        className="automation_imgs "
                        src={require("../../assets/images/Intern/Information Technology/rear-view-programmer-working-all-night-long.jpg")}
                      ></img>
                    </div>
                  </div>
                  <div className="col-lg-4 Automation_Journey_YellowColor">
                    <div className="bg-danger Automation_cardd"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- End Single Item -->*}}
                {/* what is your gain */}
        {/* modal code start */}
        {isModalOpen && (
          <div className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ marginTop: "30px" }}>
              <span className="close text-end" onClick={closeModal}>
                &times;
              </span>
              <h2>Course Details</h2>
              <form>
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="student_name"
                      name="student_name"
                      value={formValues.student_name}
                      onChange={handleChange}
                      required
                    />
                    <label>Name</label>
                    {errors.student_name && (
                      <div className="text-danger">{errors.student_name}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      placeholder=""
                      id="email"
                      name="email"
                      value={formValues.email}
                      onChange={handleChange}
                      required
                    />
                    <label>Email</label>
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="tel"
                      placeholder=""
                      id="mobile_no"
                      name="mobile_no"
                      value={formValues.mobile_no}
                      onChange={handleChange}
                      required
                    />
                    <label>Mobile</label>
                    {errors.mobile_no && (
                      <div className="text-danger">{errors.mobile_no}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <select
                      id="location"
                      name="location"
                      className="form-select"
                      value={formValues.location}
                      onChange={handleChange}
                    >
                      <option value="">Select Location</option>
                      <option value="Salem">Salem</option>
                      <option value="Erode">Erode</option>
                      <option value="Others">Others</option>
                    </select>
                    {errors.location && (
                      <div className="text-danger">{errors.location}</div>
                    )}
                  </div>

                  {showOtherLocationField && (
                    <div className="mb-3">
                      <input
                        type="text"
                        id="other_location"
                        name="other_location"
                        className="form-control"
                        placeholder="Enter Your Location"
                        value={formValues.other_location || ""}
                        onChange={handleChange}
                      />
                      {errors.location && (
                        <div className="text-danger">{errors.location}</div>
                      )}
                    </div>
                  )}

                  <div className="floating-label">
                    <input
                      type="text"
                      className="form-control"
                      name="Prefered_course"
                      value={isCourseData || formValues.Prefered_course || ""}
                      disabled // Disable input to prevent editing
                    />
                    <label>Preferred Course</label>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <p
                        className="btn btn-success"
                        onClick={handleSendMessage}
                      >
                        send
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* {isPopupOpen && (
          <div className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ marginTop: "30px" }}>
              <span
                className="close text-danger text-end"
                onClick={() => setIsPopupOpen(false)}
              >
                &times;
              </span>
              <h2>Download File</h2>

              <p>Click the button below to download the file:</p>
              <button className="btn btn-success" onClick={handleDownload}>
                Download
              </button>
            </div>
          </div>
        )} */}
        {/* modal code end */}
      </div>
    </>
  );
}

export default InformationTechnology;
